import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Legal.css';

const KVKKPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="legal-page">
            <button onClick={() => navigate(-1)} className="legal-page__back-btn">← Geri Dön</button>

            <h1>KİŞİSEL VERİLERİN KORUNMASI VE İŞLENMESİ HAKKINDA AYDINLATMA METNİ</h1>

            <p><strong>Veri Sorumlusu:</strong> Fashlytic Anonim Şirketi ("Şirket")</p>

            <p>Şirketimiz, sunduğu sanal deneme (Virtual Try-On) ve yapay zeka tabanlı içerik üretimi hizmetleri kapsamında kişisel verilerinizi 6698 sayılı Kişisel Verilerin Korunması Kanunu’na ("KVKK") uygun olarak işlemektedir.</p>

            <h2>Hangi Verilerinizi İşliyoruz?</h2>
            <ul>
                <li><strong>Görsel İşitsel Kayıtlar:</strong> Sisteme yüklediğiniz selfie (özçekim) fotoğrafları, boy fotoğrafları.</li>
                <li><strong>Biyometrik Veriler:</strong> Yüklediğiniz fotoğraflardan elde edilen yüz analizi, yüz haritası, vücut ölçüleri ve cilt tonu verileri.</li>
                <li><strong>İşlem Bilgileri:</strong> Tercih ettiğiniz kıyafetler, beden seçimleri, oluşturulan sanal kombinler.</li>
            </ul>

            <h2>Verilerin İşlenme Amacı</h2>
            <p>Kişisel ve biyometrik verileriniz;</p>
            <ul>
                <li>Yapay zeka teknolojileri kullanılarak sanal kıyafet deneme deneyiminin (FashSnap, FashPlay vb.) oluşturulması,</li>
                <li>Yüz ve vücut tipinize uygun kişiselleştirilmiş avatarların yaratılması,</li>
                <li>Oluşturulan içeriklerin ön belleğe (cache) alınarak daha sonraki ziyaretlerinizde size hızlı sunulması,</li>
            </ul>
            <p>amacıyla işlenmektedir.</p>

            <h2>Verilerin Aktarılması</h2>
            <p>Hizmetin teknik olarak sağlanabilmesi için fotoğraflarınız ve biyometrik verileriniz; görüntü işleme altyapımızı sağlayan yurt dışı menşeili sunucu ve yapay zeka servis sağlayıcılarına (Örn: Fal.ai, Google Cloud, Supabase) güvenli kriptolama yöntemleri ile aktarılmaktadır.</p>

            <h2>Haklarınız</h2>
            <p>KVKK’nın 11. maddesi uyarınca verilerinizin silinmesini, yok edilmesini veya anonim hale getirilmesini talep etme hakkına sahipsiniz.</p>
        </div>
    );
};

export default KVKKPage;
